import { render, staticRenderFns } from "./SupplierTemplateMenu.vue?vue&type=template&id=51f20708&scoped=true"
import script from "./SupplierTemplateMenu.vue?vue&type=script&lang=js"
export * from "./SupplierTemplateMenu.vue?vue&type=script&lang=js"
import style0 from "./SupplierTemplateMenu.vue?vue&type=style&index=0&id=51f20708&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f20708",
  null
  
)

export default component.exports